import { render, staticRenderFns } from "./CityFeatures.vue?vue&type=template&id=f540e09c&scoped=true"
import script from "./CityFeatures.vue?vue&type=script&lang=js"
export * from "./CityFeatures.vue?vue&type=script&lang=js"
import style0 from "./CityFeatures.vue?vue&type=style&index=0&id=f540e09c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f540e09c",
  null
  
)

export default component.exports